import React, { Component } from 'react';
import FSFlatButton from '../lib/FSFlatButton';
import componentBase from '../../lib/component-base';
import { setEnterpriseUsers, startSpinner, endSpinner } from '../../../modules/Account/redux/actions';

@componentBase('EnterpriseAdminConsole')
export default class EnterpriseAdminConsole extends Component {
  static propTypes = {};

  constructor(props, context) {
    super(props, context);

    this.state = {
      buttonsDisabled: false,
    };
  }

  _handleClear = (e) => {
    e.preventDefault();
    this.setState({
      accountIdValue: '',
      textAreaValue: '',
    });
  }

  _handleInputChange = (e) => {
    e.preventDefault();
    this.setState({
      accountIdValue: e.target.value,
    });
  }

  _handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ buttonsDisabled: true });
    this.context.store.dispatch(startSpinner());
    const emails = typeof this.state.textAreaValue === 'string' &&
    this.state.textAreaValue.split(',').map(element => element.trim()); // cleanup loose spaces on the ends

    this.context.store.dispatch(setEnterpriseUsers(this.state.accountIdValue, emails))
      .then(() => {
        this.context.toast.success('Enterprise accounts have been set', 'Success');
        this.setState({ buttonsDisabled: false }, () => this.context.store.dispatch(endSpinner()));
      })
      .catch(() => {
        this.context.toast.error('Error setting access for supplied users. Please try again.', 'Error', false, 3);
        this.setState({ buttonsDisabled: false }, () => this.context.store.dispatch(endSpinner()));
      });
  }

  _handleTextareaChange = (e) => {
    e.preventDefault();
    this.setState({
      textAreaValue: e.target.value,
    });
  }

  render() {
    return (
      <div>
        <h1>Enterprise Admin Console</h1>
        <form>
          <div className='col-xs-12'>
            <p style={{ marginTop: '25px' }}>
              Enter enterprise account id
            </p>
            <input
              type='text'
              placeholder='ex: 1'
              value={this.state.accountIdValue}
              onChange={this._handleInputChange}
              style={{
                borderRadius: '0.3em',
                width: '20%',
              }}
            />
          </div>
          <div className='col-xs-12'>
            <p style={{ marginTop: '25px' }}>
              {`Enter comma-separated email addresses to be added to enterprise account ${this.state.accountIdValue || ''}`}
            </p>
            <textarea
              placeholder='example@flightstats.com, example2@flightstats.com'
              value={this.state.textAreaValue}
              onChange={this._handleTextareaChange}
              style={{
                borderRadius: '0.3em',
                height: '200px',
                width: '60%',
              }}
            />
          </div>
          <div className='col-xs-12'>
            <FSFlatButton
              disabled={this.state.buttonsDisabled}
              label='submit'
              onClick={this._handleSubmit.bind(this)}
              style={{
                width: '220px',
                margin: '25px 50px 25px 0',
              }}
            />
            <FSFlatButton
              disabled={this.state.buttonsDisabled}
              label='clear'
              onClick={this._handleClear.bind(this)}
              style={{
                width: '220px',
                margin: '25px 0',
                backgroundColor: '#81a2ca',
              }}
            />
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/enterpriseAdminConsole/container.js